export enum EReviewStatus {
  PENDING = 'PENDING',
  PUBLISHED = 'PUBLISHED',
  REJECTED = 'REJECTED'
}

export enum EReviewEntityType {
  PRODUCT = 'PRODUCT',
  HORSE = 'HORSE',
  SERVICE = 'SERVICE'
}

export interface IReviewAuthor {
  _id: string
  name?: string
  surname?: string
  patronymic?: string
  full_name?: string
  email?: string
  tel?: number
}

export interface IReviewShop {
  _id: string
  shop_name?: string
  slug?: string
}

export interface IReviewOrder {
  _id: string
  number?: number
}

export interface IReviewEntity {
  _id: string
  name?: string
  slug?: string
}

export interface IReviewVideo {
  src: string
  poster?: string
}

export interface IReview {
  _id: string
  rating: number
  text?: string | null
  anonymity: boolean
  images?: string[]
  videos?: IReviewVideo[]
  status: EReviewStatus
  entity_id: string
  entity_type: EReviewEntityType
  author?: IReviewAuthor
  shop?: IReviewShop
  order?: IReviewOrder
  entity?: IReviewEntity
  // Автор правил отзыв: после правки он снова на модерации
  edited_at?: string | null
  createdAt: string
  updatedAt: string
}

export interface IReviewListRequest {
  skip: string
  limit: string
  statuses?: EReviewStatus[]
  seller_id?: string
}

export interface IReviewListResponse {
  reviews: IReview[]
  count: number
}

export interface IUpdateReviewStatus {
  status: EReviewStatus
}
